import React from 'react';
import style from "./style.module.scss"
import cn from "classnames";
import {Link} from "react-router-dom";
import { motion } from "framer-motion";
import {useAnimationConfig} from "../../../hooks/useAnimationConfig";
import { useSelector } from 'react-redux';

const WrapperContent = ({ children, displayCreateBtn = true, bg = false, isGap = false }) => {
  const { routeVariants} = useAnimationConfig()

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      className={cn(style.orders, {
        [style.isGap]: isGap,
      })}
      style={bg ? { backgroundColor: '#eee' } : {}}
    >
      { children }
    </motion.div>
  );
};

export default WrapperContent;